import { createContext } from 'react'

import { SmartTableContextType } from './types'

export const SmartTableContext = createContext<SmartTableContextType>({} as SmartTableContextType)
export const SmartTableProvider = SmartTableContext.Provider
